import classHierarchies from "./classHierarchies";
import movieBook from "./movieBook";
import peoplePlaces from "./peoplePlaces";

const examples = [movieBook, classHierarchies, peoplePlaces];

export default examples;
